import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import SearchFilterBox from "../../Components/SearchFilterBox";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import { Save_Owners } from "../../Redux/actions";
import { AddBtn } from "../../Components/Styles/InputStyles";
import Table from "../../Components/Receipt/Table";
import { useNavigate } from "react-router-dom";
import DeleteReceipt from "../../Components/Receipt/Delete";

const Receipt = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddReceipt, setShowAddReceipt] = useState(false);
  const [isDeleteReceipt, setIsDeleteReceipt] = useState(false);

  const getFilterType = (type) => {
    switch (type) {
      case 1:
        return "MOBILE";
      case 2:
        return "NAME";
      // case 3:
      //   return "INVENTORY_NAME";
      default:
        return "";
    }
  };

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(
      `${Config.apiUrl}/receipt/list?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res?.isSuccess) {
      const list = res?.list;

      const formattedList = Array.isArray(list) ? list : list ? [list] : [];

      setApiData(formattedList);
      dispatch(Save_Owners(formattedList));
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate({ searchQuery, filterType });
  }, []);

  const handleFilterChange = (values) => {
    const type = getFilterType(values.filterType);

    setFilterType(type);
    setSearchQuery(values.searchQuery);

    getListMutate({
      searchQuery: values.searchQuery,
      filterType: type,
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  const handleCloseAddOwner = () => {
    setShowAddReceipt(false);
  };

  //---Download Receipt---------------------------
  const downloadReceiptFunction = async (receiptId) => {
    const response = await axios.get(
      `${Config.apiUrl}/receipt/download?receiptId=${receiptId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  };

  const downloadReceiptSuccess = (res) => {
    if (res?.link) {
      window.open(res.link, "_blank");

      // OR
      // setReceiptData({
      //   link: res.link,
      //   message: res.msg,
      // });
      // setShowReceiptModal(true);
    }
  };

  const downloadReceiptError = (error) => {
    toast.error(error?.response?.data?.msg || "Unable to download receipt");
  };

  const {
    mutate: downloadReceiptMutate,
    isLoading: downloadLoading,
  } = useMutation(downloadReceiptFunction, {
    onSuccess: downloadReceiptSuccess,
    onError: downloadReceiptError,
  });


  //------- Delete Receipt -------
  const deleteReceiptFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/receipt/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteReceiptSuccess = (data) => {
    if (data?.data?.isSuccess) {
      toast.success(data?.data?.msg || "Receipt deleted successfully");
      setIsDeleteReceipt(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteReceiptError = (error) => {
    setIsDeleteReceipt(false);
    toast.error(error?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: deleteReceiptLoading,
    mutate: deleteReceiptMutate,
  } = useMutation(deleteReceiptFunction, {
    onSuccess: deleteReceiptSuccess,
    onError: deleteReceiptError,
  });

  const handleReceiptClose = () => {
    setIsDeleteReceipt(false);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          {/* Receipts */}
          Invoices
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={() => navigate("/generateinvoice")}
          >
            {"Generate Invoice"}
          </AddBtn>
        </div>
      </BoxHead>

      <FilterTableWrapper>
        <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left: Total Amount */}
          <div className="flex items-center">
            <Text>
              Total records:{" "}
              <span className="font-semibold">{apiData?.length || 0}</span>
            </Text>
          </div>

          {/* Right: Search / Filters */}
          {/* <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
          </div> */}
        </FilterWrapper>

        {isDeleteReceipt && (
          <DeleteReceipt
            setIsDeleteReceipt={setIsDeleteReceipt}
            isDeleteReceipt={isDeleteReceipt}
            deleteReceiptLoading={deleteReceiptLoading}
            deleteReceiptMutate={deleteReceiptMutate}
            selectedData={selectedData}
            handleClose={handleReceiptClose}
          />
        )}
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={apiData || []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              downloadReceiptMutate={downloadReceiptMutate}
              downloadLoading={downloadLoading}
              setIsDeleteReceipt={setIsDeleteReceipt}
            />
            {(!apiData || apiData.length === 0) && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>
      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;

const Text = tw.p`text-gray-500 text-sm font-normal`;

export default Receipt;
